import { Link } from "react-router-dom";
import { ShieldCheck, Zap, Lock, ArrowRight } from "lucide-react";

import { useTranslation } from 'react-i18next';
const GUARANTEE_FEATURES = [
  {
    icon: ShieldCheck,
    title: "FULL REFUND",
    text: "Not satisfied? Get 100% of your money back within 7 days. No questions asked.",
  },
  {
    icon: Zap,
    title: "INSTANT ACTIVATION",
    text: "Your AI agent is live in 5 minutes. If it's not working for you, cancel anytime.",
  },
  {
    icon: Lock,
    title: "NO LOCK-IN",
    text: "Cancel with one click. No contracts. No cancellation fees. No hassle.",
  },
];

export function GuaranteeSection() {
    const { t } = useTranslation();
return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24" aria-labelledby="guarantee-heading">
      <div className="text-center mb-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4" aria-hidden="true">
          // Guarantee Badge
        </div>
        <h2 id="guarantee-heading" className="font-display text-4xl md:text-5xl uppercase leading-tight">
          {t('guarantee_section.money_back_days')}
          <br />
          <span className="text-amber-500">{t('guarantee_section.guarantee')}</span>
        </h2>
        <p className="mt-4 text-zinc-400 text-lg">{t('guarantee_section.no_risk_no_questions_asked_no_fine_print')}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        {GUARANTEE_FEATURES.map((f) => {
          const Icon = f.icon;
          return (
            <div key={f.title} className="text-center p-8 border border-zinc-800 bg-zinc-950/50">
              <div className="inline-flex items-center justify-center w-14 h-14 border border-amber-500/30 bg-amber-500/10 mb-6">
                <Icon className="w-6 h-6 text-amber-500" aria-hidden="true" />
              </div>
              <h3 className="font-display text-lg uppercase mb-3">{f.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{f.text}</p>
            </div>
          );
        })}
      </div>

      <div className="text-center">
        <Link
          to="/pricing"
          className="inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-400 text-black px-10 py-5 font-bold uppercase tracking-wider text-sm transition-all hover:shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#09090B]"
        >
          {t('guarantee_section.start_your_risk_free_trial')} <ArrowRight className="w-4 h-4" aria-hidden="true" />
        </Link>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.15em] text-amber-500">
          ✨ Join 33 businesses already automating with Max OS
        </p>
      </div>
    </section>
  );
}

export function PricingGuarantee() {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" aria-labelledby="pricing-guarantee-heading">
      <div className="flex flex-col md:flex-row items-center gap-6 border border-zinc-800 bg-zinc-950/60 p-8">
        <div className="shrink-0" aria-hidden="true">
          <div className="w-12 h-12 bg-amber-500/10 border border-amber-500/30 flex items-center justify-center">
            <ShieldCheck className="w-5 h-5 text-amber-500" />
          </div>
        </div>
        <div className="text-center md:text-left">
          <h3 id="pricing-guarantee-heading" className="font-display text-xl text-white uppercase">
            7-Day Money-Back Guarantee
          </h3>
          <p className="mt-2 text-zinc-400 leading-relaxed">
            Every plan includes our 7-day money-back guarantee. If Max OS Cloud doesn't work for your business, we'll refund every penny. No questions asked.
          </p>
          <a
            href="/#guarantee"
            className="mt-3 inline-flex items-center gap-1 text-amber-500 hover:text-amber-400 font-mono text-xs uppercase tracking-[0.15em] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
          >
            Read our full guarantee <ArrowRight className="w-3 h-3" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}
